import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

import BasicAuth from '../../../../../libraries/Images/basicAuth.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="openbrowser">
                1.&nbsp;<span className="material-symbols-outlined">web_asset</span>&nbsp;{translate('openbrowser')}
            </Typography>
            <p><strong>{translate('openbrowser')}</strong> is an action that is used in almost any workflow. Launch browser (Chromium) and open the specified web page. The output will be the web address of the browser launched.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is a place to store the output of this action and to specify the browser object for other actions.</td>
                                <td>$browser_1</td>
                            </tr>
                            <tr>
                                <td>{translate('url')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The address of the web page you want to open.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('windowsize')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the screen size when starting the browser.</td>
                                <td>1280 x 1024</td>
                            </tr>
                            <tr>
                                <td>{translate('language')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser language.</td>
                                <td>English</td>
                            </tr>
                            <tr>
                                <td>{translate('basicauthusername')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The username in the dialog box (see ❶ in the supplement).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('basicauthpassword')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The password in the dialog (see ❷ in the supplement).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('acceptdialog')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>The action of clicking the button of the dialog, if the <strong>{translate('acceptdialog')}</strong> switch is on (true) then clicking <strong>{translate('signin')}</strong> button (see number ❸ in the supplement).</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>In case the browser displays a dialog box.</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('url')}</span>
                            <div>https://rpa-cloud.io/</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>ws://127.0.0.1:58580/devtools/browser/e490bb1b-e478-48c2-a8e1-7f5e2da46e0</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="typetext">
                2.&nbsp;<span className="material-symbols-outlined">text_fields</span>&nbsp;{translate('typetext')}
            </Typography>
            <p><strong>{translate('typetext')}</strong> Type Text is an action of entering text into a specified element in the browser, one by one as human does.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object you want to enter text on in the browser. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The text you want to input.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('clearvalue')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Is the action of deleting all the text, if the <strong>{translate('clearvalue')}</strong> switch is on (true), the previous text will be deleted and replaced with new text.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As an action that ignores errors, if the <strong>{translate('ignoreerror')}</strong> switch is on (true) the browser will continue with further actions even if an error occurs such as the CSS selector not being found.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>input.username</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>support@rpa-cloud.io</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="typepassword">
                3.&nbsp;<span className="material-symbols-outlined">password</span>&nbsp;{translate('typepassword')}
            </Typography>
            <p><strong>{translate('typepassword')}</strong> works the same as {translate('typetext')}, but the password will be hidden.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object you want to enter the password on in the browser. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Password<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The password you want to enter.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('clearvalue')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Is the action of deleting all the text, if the <strong>{translate('clearvalue')}</strong> switch is on (true), the previous text will be deleted and replaced with new text.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As an action that ignores errors, if the <strong>{translate('ignoreerror')}</strong> switch is on (true) the browser will continue with further actions even if an error occurs such as the CSS selector not being found.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>input.password</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>Password</span>
                            <div>Abc123#</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="click">
                4.&nbsp;<span className="material-symbols-outlined">ads_click</span>&nbsp;{translate('click')}
            </Typography>
            <p><strong>{translate('click')}</strong> is the act of clicking on a specified element in the browser.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object you want to click on in the browser. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('waitfornavigation')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As the browser's action to wait for navigation, if the <strong>{translate('waitfornavigation')}</strong> switch is on (true) then the browser will explicitly wait for this event to occur and then proceed to the next action.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('acceptdialog')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>The action of clicking the button of the dialog, if the <strong>{translate('acceptdialog')}</strong> switch is on (true) then clicking <strong>{translate('signin')}</strong> button (see number ❸ in the supplement).</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As an action that ignores errors, if the <strong>{translate('ignoreerror')}</strong> switch is on (true) the browser will continue with further actions even if an error occurs such as the CSS selector not being found.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>In case the browser displays a dialog box.</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>button.signin</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="selectoption">
                5.&nbsp;<span className="material-symbols-outlined">checklist</span>&nbsp;{translate('selectoption')}
            </Typography>
            <p><strong>{translate('selectoption')}</strong> is the action of selecting a dropdown list by its display name (inner text).</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the dropdown list. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Is the display name (inner text) of the option.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As an action that ignores errors, if the <strong>{translate('ignoreerror')}</strong> switch is on (true) the browser will continue with further actions even if an error occurs such as the CSS selector not being found.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>select.gender</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>male</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="keyboardpress">
                6.&nbsp;<span className="material-symbols-outlined">keyboard_command_key</span>&nbsp;{translate('keyboardpress')}
            </Typography>
            <p><strong>{translate('keyboardpress')}</strong> are keyboard actions.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('keyboards')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The name of a key on the keyboard. See <a href="https://github.com/puppeteer/puppeteer/blob/1ecb6e3f19c970257626d58ea2fa5323195fc1f2/src/common/USKeyboardLayout.ts" target="_blank">here</a> for a list of the available key names.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('keyboards')}</span>
                            <div>ArrowLeft,Enter</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="downloadfile">
                7.&nbsp;<span className="material-symbols-outlined">file_download</span>&nbsp;{translate('downloadfile')}
            </Typography>
            <p><strong>{translate('downloadfile')}</strong> is the act of downloading a file, the file will be saved in the storage.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place that the output of this action and the download file is stored.</td>
                                <td>$file_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('actionsfordownload')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The action to trigger the file to download. Note that if the action is <strong>{translate('selectoption')}</strong>, the <strong>{translate('text')}</strong> value must be entered.</td>
                                <td>{translate('click')}</td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object that wants to trigger the file download on the browser. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the display name (inner text) of the option.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As an action that ignores errors, if the <strong>{translate('ignoreerror')}</strong> switch is on (true) the browser will continue with further actions even if an error occurs such as the CSS selector not being found.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$file_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('actionsfordownload')}</span>
                            <div>Click</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>button.download</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/bot-sktwi9ovlb7lrmpt/his-20221208-0531394260/data.xlsx</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="uploadfile">
                8.&nbsp;<span className="material-symbols-outlined">file_upload</span>&nbsp;{translate('uploadfile')}
            </Typography>
            <p><strong>{translate('uploadfile')}</strong> is the act of uploading files to the browser from the storage.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object that wants to upload the file on the browser. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the storage address of the file you want to upload.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>input.upload</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/downloads/bot-sktwi9ovlb7lrmpt/his-20221208-0531394260/data.xlsx</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="gettext">
                9.&nbsp;<span className="material-symbols-outlined">text_increase</span>&nbsp;{translate('gettext')}
            </Typography>
            <p><strong>{translate('gettext')}</strong> is the action of getting all the text in the specified element in the browser.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>This is where the output of this action is stored.</td>
                                <td>$text_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object that wants to get the text. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As an action that ignores errors, if the <strong>{translate('ignoreerror')}</strong> switch is on (true) the browser will continue with further actions even if an error occurs such as the CSS selector not being found.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$text_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>p.google</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>Google is a technology company</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="clickpoint">
                10.&nbsp;<span className="material-symbols-outlined">my_location</span>&nbsp;{translate('clickpoint')}
            </Typography>
            <p><strong>{translate('clickpoint')}</strong> is the act of clicking at the location specified by the x,y coordinates. If a selector is present, then the x, y coordinates can be specified with the upper left of the element specified by the selector as the reference point.</p>
            <p>You can install the utility to get x, y coordinates <a href="https://chrome.google.com/webstore/detail/coordinates/bpflbjmbfccblbhlcmlgkajdpoiepmkd" target="_blank">here</a>.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object you want to click on in the browser. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('coordinatex')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Is the X coordinate (unit is pixel).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('coordinatey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Is the Y coordinate (unit is pixel).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('waitfornavigation')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>It's the browser's navigation waiting action, if the <strong>{translate('waitfornavigation')}</strong> switch is on (true) then the browser will explicitly wait for this event to occur and then continue to perform the next action.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('acceptdialog')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>The action of clicking the button of the dialog, if the <strong>{translate('acceptdialog')}</strong> switch is on (true), click <strong>{translate('signin')}</strong> button (see number ❸ in the supplement).</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As an action that ignores errors, if the <strong>{translate('ignoreerror')}</strong> switch is on (true) the browser will continue with further actions even if an error occurs such as the CSS selector not being found.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>In case the browser displays a dialog box.</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$text_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('coordinatex')}</span>
                            <div>200</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('coordinatey')}</span>
                            <div>500</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="takescreenshot">
                11.&nbsp;<span className="material-symbols-outlined">panorama</span>&nbsp;{translate('takescreenshot')}
            </Typography>
            <p><strong>{translate('takescreenshot')}</strong> is the act of saving the browser screen as a picture.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is where the output of this action is stored and where the image is saved.</td>
                                <td>$screenshot_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('clip')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Specify the screenshot image cropping area (left, top, width, height).The values are separated by commas. If left blank, the full screen will be captured.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$screenshot_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('clip')}</span>
                            <div>0,100,500,500</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/bot-sktwi9ovlb7lrmpt/his-20221208-0531394260/149a0611.png</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="pagepdf">
                12.&nbsp;<span className="material-symbols-outlined">panorama</span>&nbsp;{translate('pagepdf')}
            </Typography>
            <p><strong>{translate('pagepdf')}</strong> is the act of exporting a rendered page to a PDF for printing.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action and the address to save the PDF file.</td>
                                <td>$pdf_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('format')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the paper size.</td>
                                <td>A4</td>
                            </tr>
                            <tr>
                                <td>{translate('scale')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the print rate.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('pageranges')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Specifies the printed pages. Leave blank to print all pages. You can specify ranges using the - sign, and multiple ranges are separated by commas.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>pdf_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('format')}</span>
                            <div>A4</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/bot-sktwi9ovlb7lrmpt/his-20221208-0531394260/149a0611.pdf</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="hover">
                13.&nbsp;<span className="material-symbols-outlined">mouse</span>&nbsp;{translate('hover')}
            </Typography>
            <p><strong>{translate('hover')}</strong> is the act of hovering the mouse over a specified element in the browser.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object you want to scrape on the browser. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As an action that ignores errors, if the <strong>{translate('ignoreerror')}</strong> switch is on (true) the browser will continue with further actions even if an error occurs such as the CSS selector not being found.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>ul.navigate</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="scrapepage">
                14.&nbsp;<span className="material-symbols-outlined">list_alt</span>&nbsp;{translate('scrapepage')}
            </Typography>
            <p><strong>{translate('scrapepage')}</strong> is the act of getting the text or inner HTML of all elements that match a CSS selector.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is where the output of this action is stored and is the text list that is obtained as an array.</td>
                                <td>$scrape_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object you want to hover over on the browser. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('textonly')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Is an option to only get the text in the element, if the <strong>{translate('textonly')}</strong> switch is enabled (true) then the result will be text and otherwise the result will include HTML.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As an action that ignores errors, if the <strong>{translate('ignoreerror')}</strong> switch is on (true) the browser will continue with further actions even if an error occurs such as the CSS selector not being found.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$scrape_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>p.season</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(["spring", "summer", "fall", "winter"], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="extractdatafromtable">
                15.&nbsp;<span className="material-symbols-outlined">table</span>&nbsp;{translate('extractdatafromtable')}
            </Typography>
            <p><strong>{translate('extractdatafromtable')}</strong> is the act of getting the text from a table located on the website.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is where the output of this action is stored and is the text list that is obtained as an array.</td>
                                <td>$extractDataFromTable_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object you want to hover over on the browser. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As an action that ignores errors, if the <strong>{translate('ignoreerror')}</strong> switch is on (true) the browser will continue with further actions even if an error occurs such as the CSS selector not being found.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$extractDataFromTable_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>div.exchange-rate-table</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify([
                                        ["No", "Product Name", "Price"],
                                        [1, "Pen", 200],
                                        [2, "note", 500]
                                    ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="findelement">
                16.&nbsp;<span className="material-symbols-outlined">manage_search</span>&nbsp;{translate('findelement')}
            </Typography>
            <p><strong>{translate('findelement')}</strong> is an action that allows to access the element displayed in the browser in different ways.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$element_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('findelementby')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>
                                    The method that retrieves the element displayed in the browser.
                                    <ul>
                                        <li>If <strong>{translate('text')}</strong> is selected, the result will be an array of CSS selectors.</li>
                                        <li>If you choose <strong>{translate('selector')}</strong>, the result will be <i>true</i> or <i>false</i>.</li>
                                    </ul>
                                </td>
                                <td>Text</td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the text you want to access on the browser.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object you want to access on the browser. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                    <br/>
                    <ReturnTypeValue type="boolean" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$element_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('findelementby')}</span>
                            <div>Text</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>Sign In</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(["input.signin"], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
                <br />
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$element_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('findelementby')}</span>
                            <div>Selector</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>input.signin</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>true</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="geturl">
                17.&nbsp;<span className="material-symbols-outlined">lock</span>&nbsp;{translate('geturl')}
            </Typography>
            <p><strong>{translate('geturl')}</strong> is an action that gets the URL of the website you are viewing.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>https://rpa-cloud.io/</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getattribute">
                18.&nbsp;<span className="material-symbols-outlined">font_download</span>&nbsp;{translate('getattribute')}
            </Typography>
            <p><strong>{translate('getattribute')}</strong> is an action that takes the attribute value of the element specified by a CSS selector.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object that wants to get the attribute value on the browser. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('attribute')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Are the attributes to be retrieved like (id, src, href, alt, etc.)</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As an action that ignores errors, if the <strong>{translate('ignoreerror')}</strong> switch is on (true) the browser will continue with further actions even if an error occurs such as the CSS selector not being found.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>img.logo</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('attribute')}</span>
                            <div>src</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>https://rpa-cloud.io/static/media/logo.c2d9a6453b58088f8c6bb284148a556d.svg</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="waitforselector">
                19.&nbsp;<span className="material-symbols-outlined">hourglass_empty</span>&nbsp;{translate('waitforselector')}
            </Typography>
            <p><strong>{translate('waitforselector')}</strong> is an action that waits until the <strong>{translate('selector')}</strong> is present in the page.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object you want to wait in the browser. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('timeout')}</td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Is the maximum wait time in milliseconds. If left blank, the default is 180000.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As an action that ignores errors, if the <strong>{translate('ignoreerror')}</strong> switch is on (true) the browser will continue with further actions even if an error occurs such as the CSS selector not being found.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>div.bannel</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="draganddrop">
                20.&nbsp;<span className="material-symbols-outlined">move_down</span>&nbsp;{translate('draganddrop')}
            </Typography>
            <p><strong>{translate('draganddrop')}</strong> is a drag and drop action by specifying the element being dragged and the element being dropped.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('targetselector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object that you want to drag on the browser. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('destinationselector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the CSS selector of the object that you want to drop on the browser. Please see <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">here</a> how to get CSS selectors.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As an action that ignores errors, if the <strong>{translate('ignoreerror')}</strong> switch is on (true) the browser will continue with further actions even if an error occurs such as the CSS selector not being found.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('targetselector')}</span>
                            <div>div#div1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('destinationselector')}</span>
                            <div>div#div2</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="injectjavascript">
                21.&nbsp;<span className="material-symbols-outlined">javascript</span>&nbsp;{translate('injectjavascript')}
            </Typography>
            <p><strong>{translate('injectjavascript')}</strong> is an action that lets you execute JavaScript inside the page.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$injectJavaScript_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('code')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>JavaScript code.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('code')}</span>
                            <div>
                                let x = 1;<br />
                                let y = 2;<br />
                                return x + y;
                            </div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>3</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="gotourl">
                22.&nbsp;<span className="material-symbols-outlined">open_in_browser</span>&nbsp;{translate('gotourl')}
            </Typography>
            <p><strong>{translate('gotourl')}</strong> is an action that allows you to type a URL directly into your browser's address bar and make the conversion. It can be used to forward pages while maintaining a session, or to instantly switch to layers deep in a web page by specifying a URL.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('url')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the address of the website you want to go.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('acceptdialog')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>The action of clicking the button of the dialog, if the <strong>{translate('acceptdialog')}</strong> switch is on (true) then clicking <strong>{translate('signin')}</strong> button (see number ❸ in the supplement).</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>In case the browser displays a dialog box.</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('url')}</span>
                            <div>https://rpa-cloud.io/signin/</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="goback">
                23.&nbsp;<span className="material-symbols-outlined">arrow_back</span>&nbsp;{translate('goback')}
            </Typography>
            <p><strong>{translate('goback')}</strong> is an act of navigating to the previous page in the navigation history.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="opennewtab">
                24.&nbsp;<span className="material-symbols-outlined">tab</span>&nbsp;{translate('opennewtab')}
            </Typography>
            <p><strong>{translate('opennewtab')}</strong> is an act of open a new tabs/windows on your browser.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('url')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The address of the web page you want to open.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('acceptdialog')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>The action of clicking the button of the dialog, if the <strong>{translate('acceptdialog')}</strong> switch is on (true) then clicking <strong>{translate('signin')}</strong> button (see number ❸ in the supplement).</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>In case the browser displays a dialog box.</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('url')}</span>
                            <div>https://rpa-cloud.io/</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="switchtab">
                25.&nbsp;<span className="material-symbols-outlined">tab</span>&nbsp;{translate('switchtab')}
            </Typography>
            <p><strong>{translate('switchtab')}</strong> is an act of navigating between open tabs/windows on your browser.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('tab')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Is the tab position you want to move. Enter 1 to specify the oldest tab. "1", "2", etc. in the order in which the tabs are opened. You can also specify the Tab object itself which can be obtained with <strong>{translate('showtabs')}</strong>.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="showtabs">
                26.&nbsp;<span className="material-symbols-outlined">tab_unselected</span>&nbsp;{translate('showtabs')}
            </Typography>
            <p><strong>{translate('showtabs')}</strong> is an action that retrieves all open tabs/windows in the browser displayed in the order they were opened as arrays.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is where the output of this action and the list of tabs/windows are stored as an array.</td>
                                <td>$tabs_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$tabs_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            {
                                                "id": 1,
                                                "url": "https://rpa-cloud.io/",
                                                "title": "RPA CLOUD",
                                            }
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="closetab">
                27.&nbsp;<span className="material-symbols-outlined">tab_close</span>&nbsp;{translate('closetab')}
            </Typography>
            <p><strong>{translate('closetab')}</strong> is an act of closing a tab on your browser.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('tab')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Is the tab position you want to close. Enter 1 to specify the oldest tab. "1", "2", etc. in the order in which the tabs are opened. You can also specify the Tab object itself which can be obtained with <strong>{translate('showtabs')}</strong>.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>An image taken after the browser completes the action, if the <strong>{translate('screenshot')}</strong> switch is turned on (true), the image will be captured and saved in the storage.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="closebrowser">
                28.&nbsp;<span className="material-symbols-outlined">web_asset_off</span>&nbsp;{translate('closebrowser')}
            </Typography>
            <p><strong>{translate('closebrowser')}</strong> is an action that closes any open tabs/windows on your browser.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The browser connection address.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);